// Resolves the Convex HTTP actions site URL.
// In dev: Vite proxies /api → Convex; in prod: same-origin if frontend is hosted
// on the same domain, otherwise a separate Convex deployment URL.

const convexCloudUrl = import.meta.env.VITE_CONVEX_URL || "";
const convexSiteUrl = import.meta.env.VITE_CONVEX_SITE_URL || "";

export function convexApiBaseUrl() {
    // Prefer the *.convex.site URL (Convex HTTP actions live there).
    if (convexSiteUrl) return convexSiteUrl.replace(/\/$/, "");
    // Fallback: derive from cloud URL (strip ".cloud" → ".site")
    if (convexCloudUrl) {
        return convexCloudUrl.replace(".convex.cloud", ".convex.site").replace(/\/$/, "");
    }
    return "";
}

export function convexCloudBaseUrl() {
    return convexCloudUrl.replace(/\/$/, "");
}

export async function convexApiFetch(path, options = {}) {
    const base = convexApiBaseUrl();
    if (!base) {
        throw new Error("Convex URL not configured. Set VITE_CONVEX_URL in your .env.");
    }
    return fetch(`${base}${path}`, {
        ...options,
        credentials: "include", // critical for sending/receiving the httpOnly cookie
        headers: {
            "Content-Type": "application/json",
            ...(options.headers || {}),
        },
    });
}
